import { useQuery } from "@tanstack/react-query";
import getBoletinsCategories from "Api/boletins/categories";

export default function useBoletinsCategories() {
  return useQuery<string[]>(["categories"], () => getBoletinsCategories());
}
